import cx from 'classnames';
import {memo, useEffect} from 'react';
import {Route, useRouteMatch} from 'react-router-dom';
import {ResendInvitationProvider} from '~/overview/contexts/ResendInvitationContext';
import {GuestSummary} from '~/ViewInvitation/components/Guestlist/GuestSummary';
import {Guests} from '~/ViewInvitation/components/Guestlist/Guests';
import {RsvpSettings} from '~/ViewInvitation/components/Guestlist/RsvpSettings';
import {UpdateGuest} from '~/ViewInvitation/components/Guestlist/UpdateGuest';
import {UpdateRSVP} from '~/ViewInvitation/components/Guestlist/UpdateRSVP';
import {ResponsivePanel} from '~library/organisms/ResponsivePanel';

import * as styles from './GuestlistOverlay.module.scss';

export interface GuestlistRouteParams {
  userId: string;
}

interface GuestlistOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}

export const GuestlistOverlay = memo(({isOpen, onClose}: GuestlistOverlayProps) => {
  const onSummaryPage = useRouteMatch(`/guests/:userId`)?.isExact;

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    // TODO: build a new slideout panel component
    const slideoutPanel = document.querySelector('.slideout-panel-content') as HTMLElement;
    if (slideoutPanel) {
      slideoutPanel.style.height = '100dvh';
      slideoutPanel.style.overflowY = 'unset';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  return (
    <ResponsivePanel
      showHeader={false}
      isOpen={isOpen}
      onClose={onClose}
      renderMobileViewAs="modal"
      fallbackFocus={() => document.body}
      className={cx(styles.overlay, {
        [styles.responsivePanelLinen]: onSummaryPage,
      })}
      hideHeaderDivider
      showCover
      portalMode
    >
      <Route path="/guests" exact>
        <Guests onClose={onClose} />
      </Route>
      <Route path={`/guests/:userId`} exact>
        <ResendInvitationProvider>
          <GuestSummary onClose={onClose} />
        </ResendInvitationProvider>
      </Route>
      <Route path={`/guests/:userId/update`} exact>
        <UpdateGuest onClose={onClose} />
      </Route>
      <Route path={`/guests/:userId/update-rsvp`} exact>
        <UpdateRSVP onClose={onClose} />
      </Route>
      <Route path={`/guests/rsvp-settings`} exact>
        <RsvpSettings onClose={onClose} />
      </Route>
    </ResponsivePanel>
  );
});

GuestlistOverlay.displayName = 'GuestlistOverlay';
